const chart = {
  chartInfo: {
    name: "姓名",
    gender: "性別",
    birthDate: "出生日期",
    solarDate: "陽曆日期",
    shengXiao: "生肖",
    fiveElement: "五行",
    lunarDate: "農曆日期",
  },

  myChart: {
    title: "我的紫微斗數星盤",
    subtitle: "查看您個人的紫微斗數星盤和分析",
    profileDetails: "檔案詳情",
    keySummary: "關鍵摘要",
    detailedAnalysis: "詳細分析",
    createProfile: "建立您的個人資料",
    createProfileDesc: "要生成您的個人紫微斗數星盤，請提供您的出生資訊。",
    editProfile: "編輯個人資料",
    career: "事業與財富",
    health: "健康與養生",
    relationships: "人際關係與家庭",
    lifePurpose: "人生目標與精神追求",
    chartVisualization: "星盤視覺化",
    createOtherProfile: "為他人建立檔案",
    fields: {
      name: "姓名",
      type: "類型",
      birthDate: "出生日期",
      birthTime: "出生時間",
      gender: "性別",
      male: "男",
      female: "女",
      self: "本人",
      other: "他人",
    },
  },

  result: {
    loading: "正在載入命盤...",
    chart: "命盤",
    subtitle: "紫微斗數命盤分析",
    profileDetails: "個人資料詳情",
    chartVisualization: "命盤視覺化",
    chartVisualizationPlaceholder: "這是一個佔位符視覺化。在完整實現中，這裡將顯示互動式紫微斗數命盤。",
    shareChart: "分享",
    print: "列印",
    exportTitle: "紫微斗數命盤分析",
    generatedOn: "生成於",
    confidential: "機密報告 - 僅供個人使用",
    refreshChart: "重新整理命盤",
    detailedAnalysis: "詳細分析",
    keyInsights: "關鍵洞見",
    house: "宮",
    scrollToView: "滾動查看整個命盤",
    pinchToZoom: "捏合縮放",
    viewportInstructions: "使用縮放控制項和滾動查看命盤的所有部分",
    fields: {
      relationship: "關係",
      birthPlace: "出生地",
      generated: "生成",
    },
    insights: {
      lifePath: "人生道路",
      lifePathText: "人生道路洞見",
      personality: "性格特質",
      personalityText: "性格特質分析",
      fortune: "財富運勢",
      fortuneText: "財富預測",
    },
    analysis: {
      careerWealth: "事業與財富",
      careerWealthText: "事業與財富詳細分析。",
      suitableCareer: "適合的職業",
      suitableCareerText: "技術，金融，研究",
      financialOutlook: "財務前景",
      financialOutlookText: "穩定且具有增長潛力",
      relationshipsFamily: "人際關係與家庭",
      relationshipsFamilyText: "人際關係與家庭分析。",
      relationshipStyle: "關係風格",
      relationshipStyleText: "忠誠，耐心，善於分析",
      compatibleSigns: "相配的生肖",
      compatibleSignsText: "馬，兔，羊",
      healthWellness: "健康與養生",
      healthWellnessText: "健康與養生分析。",
      strengths: "優勢",
      strengthsText: "強健的免疫系統，充沛的生命能量",
      areasAttention: "需要關注的領域",
      areasAttentionText: "消化系統，壓力管理",
      lifePurpose: "人生目標與潛能",
      lifePurposeText: "人生目標與潛能分析。",
      naturalTalents: "天賦才能",
      naturalTalentsText: "分析能力，溝通能力，解決問題能力",
      lifeLessons: "人生課題",
      lifeLessonsText: "平衡，情感表達，信任",
    },
    exportPdf: "匯出PDF",
    hourAdjustment: {
      title: "調整出生時辰",
      description: "循環瀏覽12個時辰（地支）以探索命盤變化",
      original: "原始",
      reset: "重置為原始時辰",
      previous: "上一個",
      next: "下一個",
    },
  },

  pdfExport: {
    title: "紫微斗數命盤分析",
    subtitle: "專業占星報告",
    profileTitle: "個人資料資訊",
    reportGenerated: "報告生成於",
    confidential: "本報告為機密文件，僅供個人使用。",
    chartDescription: "命盤說明",
    chartInfo: "此紫微斗數命盤展示了出生時的天象影響。每個宮位包含特定的星曜，影響生活的不同方面。這些星曜的排列提供了對性格、命運和人生模式的洞見。",
    reportFooter: "報告結束",
    disclaimer: "本報告基於傳統中國占星學原理生成。結果應視為指引而非絕對預測。",
    pageNumber: "第",
    exporting: "正在為您準備報告，請稍候...",
    success: "匯出完成",
    failed: "匯出失敗",
    errorMessage: "目前無法完成下載，請稍後再試。",
    successMessage: "您的命盤已準備完成！",
    downloadStarted: "下載將自動開始。",
    processingChart: "請稍候，正在把您的報告整理好...",
    progress: "進度",
    chartName: "命盤",
    step1: "正在彙整您的命盤資料...",
    step2: "正在生成報告封面...",
    step3: "正在排版命盤圖像...",
    step4: "正在優化閱讀版面...",
    step5: "即將完成下載...",
    starting: "正在為您準備報告，請稍候...",
    serverRendering: "正在把命盤排成清楚、好保存的頁面...",
    serverPhase2: "還要一會兒，完整報告內容多時會稍慢，請稍候...",
    serverPhase3: "還在處理。如果同時有好幾份報告在匯出，你的會按順序排隊。",
    noSession: "請先登入後再下載命盤報告。",
    noData: "沒有可匯出的命盤資料",
    notSupported: "此瀏覽器不支援PDF匯出",
  },
};

export default chart;
